export const baseURL = "https://apiloyalty.novusloyalty.com/web/api/";
export const cardUrl = 'https://buy.stripe.com/8wM4gC7oh0bJ7qodQR'

export const FULFIL_CLIENT_ID_SOBISCO = "sobisco_261125051811638997310962817222"
export const FULFIL_SECRET_KEY_SOBISCO = "RWGJHXMZIK"